import {Person} from './person';
export class User extends Person{
    public id:number;
    public username:string = "";
    public pass:string = "";
    public status:string ="";
    public profile : Perfil = new Perfil;
    public sesion:number;
    public clientName:string;
    public typeuser:string;
}
export class Logueo extends Person{
    public id:string;
    public ruc:string = "";
    public typeDoc:string = "";
    public username:string ="";
    public pass:string ="";
}
export class Perfil{
    public idProfile : number;
    public nameProfile:string;
}
export class Contrasenia {
    public usuario:string = "";
    public password:string = "";
    public newpassword:string = "";
}
